export default "__VITE_ASSET__DMIJFIyp__"